function servicesScroll() {
	const sections = document.querySelectorAll('.teaser--services')
	if (!sections.length) return

	const setup = (section) => {
		const wrapper = section.querySelector('.teaser--services__wrapper')
		const inner = section.querySelector('.teaser--services__inner')
		if (!wrapper || !inner) return

		const items = inner.querySelectorAll('.item--wrapper')
		if (items.length >= 3) {
			const threeItemsHeight = Array.from(items).slice(0, 3).reduce((sum, el) => sum + el.offsetHeight, 0)
			const paddingBlock = parseFloat(getComputedStyle(inner).paddingTop) || 0
			wrapper.style.maxHeight = (threeItemsHeight + paddingBlock * 2) + 'px'
		}

		const col = wrapper.parentElement
		col.style.paddingBottom = ''
		const oldSpacer = col.querySelector('.teaser--services__spacer')
		if (oldSpacer) oldSpacer.remove()

		const maxScroll = inner.offsetHeight - wrapper.offsetHeight
		if (maxScroll > 0) {
			const spacer = document.createElement('div')
			spacer.className = 'teaser--services__spacer'
			spacer.style.height = maxScroll + 'px'
			col.insertBefore(spacer, wrapper.nextSibling)
		}
	}

	const update = () => {
		sections.forEach((section) => {
			const wrapper = section.querySelector('.teaser--services__wrapper')
			const inner = section.querySelector('.teaser--services__inner')
			if (!wrapper || !inner) return

			const maxScroll = inner.offsetHeight - wrapper.offsetHeight
			if (maxScroll <= 0) return

			const stickyTop = parseFloat(getComputedStyle(wrapper).top) || 0
			const sectionRect = section.getBoundingClientRect()
			const scrolled = Math.max(0, -sectionRect.top)
			const scrollableRange = section.offsetHeight - stickyTop - wrapper.offsetHeight
			const progress = Math.min(scrolled / scrollableRange, 1)

			inner.style.transform = `translateY(${-(progress * maxScroll)}px)`
		})
	}

	sections.forEach(setup)
	new ResizeObserver(() => {
		sections.forEach(setup)
		update()
	}).observe(document.body)
	window.addEventListener('scroll', update, { passive: true })
	update()
}

export { servicesScroll }
